import { ClickFormsAdjustmentGridFieldsMap } from '../../types.ts';

export const FNMA1004C_TOTAL_ROWS = 669;
export const FNMA1004C_SALES_COMP_GRID_ROWS_PER_COMP = 62;

export const FNMA1004C_ADJUSTMENT_FIELDS: ClickFormsAdjustmentGridFieldsMap = {
  salePrice: 411,
  saleFinanceAdj: 418,
  concAdj: 420,
  dateOfSaleAdj: 422,
  locationAdj: 424,
  propRightsAdj: 426,
  siteAdj: 428,
  viewAdj: 430,
  designAdj: 432,
  qualityAdj: 434,
  actualAgeAdj: 436,
  conditionAdj: 438,
  aboveGradeAdj: 439,
  roomCountAdj: 443,
  glaAdj: 445,
  basementLine1Adj: 447,
  basementLine2Adj: 449,
  funcUtilAdj: 451,
  heatingCoolingAdj: 453,
  energyEffAdj: 455,
  garageCarportAdj: 457,
  porchPatioAdj: 459,
  blank1Adj: 461,
  blank2Adj: 463,
  blank3Adj: 465,
};

export const FNMA1004C_ROWS = {
  SU_BLANK1_LABEL: 402,
  SU_BLANK2_LABEL: 404,

  // COST APPROACH
  CA_SUPPORT_FOR_SITE_VALUE: 297,
  CA_REPRODUCTION_CHECKBOX: 298,
  CA_REPLACEMENT_COST_NEW_CHECKBOX: 299,
  CA_COST_DATA_SOURCE: 300,
  CA_EFFECTIVE_DATE: 301,
  CA_QUALITY: 302,

  CA_OPINION_OF_SITE_VALUE: 303,
  CA_SECTION1_SQFT: 304,
  CA_SECTION1_COST_PER_SQFT: 305,
  CA_SECTION1_COST: 306,
  CA_SECTION2_SQFT: 307,
  CA_SECTION2_COST_PER_SQFT: 308,
  CA_SECTION2_COST: 309,
  CA_SECTION3_SQFT: 310,
  CA_SECTION3_COST_PER_SQFT: 311,
  CA_SECTION3_COST: 312,
  CA_SECTION4_SQFT: 313,
  CA_SECTION4_COST_PER_SQFT: 314,
  CA_SECTION4_COST: 315,
  CA_OTHER1_LABEL: 316,
  CA_OTHER1_SQFT: 317,
  CA_OTHER1_COST_PER_SQFT: 318,
  CA_OTHER1_COST: 319,
  CA_OTHER2: 320,
  CA_OTHER2_COST: 321,
  CA_OTHER3: 322,
  CA_OTHER3_COST: 323,
  CA_SUBTOTAL: 324,
  CA_COST_MULTIPLIER: 325,
  CA_MODIFIED_SUBTOTAL: 326,
  CA_DEPR_PHYS: 328,
  CA_DEPR_FUNC: 329,
  CA_DEPR_EXTN: 330,
  CA_DEPR_COST_OF_IMPROVEMENTS: 322,
  CA_MARKET_VALUE_OF_SITE: 333,
  CA_INDICATED_VALUE: 334,

  CA_TOTAL_GLA: 347,

  CA_ESTIMATED_REMAINING_ECON_LIFE: 360,
  CA_COMMENTS: 361,
  CA_EFFECTIVE_AGE: 185,
};
